import React, { useEffect, useState } from "react";
import { Wrap, Filter, Houses } from "./style";
import { useQuery } from "react-query";
import { useHousesContext } from "../../context/Houses";
import { useAxios } from "../../hooks/useAxios";
import { Pagination } from "antd";
import Card from "../Generic/Card";
import NoData from "../Generic/NoData";
import { formatFilteredDataUrl } from "../../utils/format";
import { NavLink } from "react-router-dom";

export default function BuyComponent() {
  const [filtededFields, setFilteredFields] = useState({
    address: "",
    city: "",
    country: "",
    first_name: "",
    house_name: "",
    max_price: 2700,
    min_price: 100,
    region: "",
    room: "",
    zip_code: "",
    sort: "",
  });
  const [localState, setLocalState] = useState({
    address: "",
    city: "",
    country: "",
    first_name: "",
    house_name: "",
    max_price: 2700,
    min_price: 100,
    region: "",
    room: "",
    zip_code: "",
    sort: "",
  });
  const [{ size, page, filtered, total, housesList }, dispatch] =
    useHousesContext();
  const { request } = useAxios();

  const getHouses = useQuery(
    ["fetchHouses", page, size, filtered],
    () =>
      request({
        url: formatFilteredDataUrl(
          `/v1/houses?page=${page - 1}&size=${size}`,

          {
            address: filtered?.address,
            city: filtered?.city,
            country: filtered?.country,
            first_name: filtered?.first_name,
            last_name: filtered?.last_name,
            house_name: filtered?.house_name,
            max_price: filtered?.max_price,
            min_price: filtered?.min_price,
            region: filtered?.region,
            room: filtered?.room,
            zip_code: filtered?.zip,
            sort: filtered?.sort,
          }
        ),
      }),
    {
      onSuccess: (res) => {
        res?.data?.success &&
          dispatch({ type: "setHouses", payload: res?.data?.dataList[0] });
        dispatch({ type: "setTotal", payload: res?.data?.map?.total_elements });
      },
      onError: (err) => console.log(err),
    }
  );
  const onShowSizeChange = (current, size) => {
    dispatch({
      type: "changePage",
      payload: current,
    });

    dispatch({
      type: "setSize",
      payload: size,
    });
  };
  const handlePaginationChange = (n) => {
    dispatch({ type: "changePage", payload: n });
  };
  const handleSlider = (v) => {
    setFilteredFields({
      min_price: v[0],

      max_price: v[1],
    });
  };
  const handleStateChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setLocalState({
      ...localState,
      [name]: value,
    });
  };
  useEffect(() => {
    dispatch({ type: "setFilterd", payload: filtededFields });
  }, []);
  const handleFind = () => {
    dispatch({ type: "changePage", payload: 1 });
    setFilteredFields({
      address: localState?.address,
      city: localState?.city,
      country: localState?.country,
      first_name: localState?.first_name,
      last_name: localState?.last_name,
      house_name: localState?.house_name,
      max_price: localState?.max_price,
      min_price: localState?.min_price,
      region: localState?.region,
      room: localState?.room,
      zip_code: localState?.zip,
      sort: localState?.sort,
    });
    getHouses.refetch();
  };
  const refresh = () => {
    setFilteredFields({
      address: "",
      city: "",
      country: "",
      first_name: "",
      house_name: "",
      max_price: 2700,
      min_price: 100,
      region: "",
      room: "",
      zip_code: "",
      sort: "",
    });
    setLocalState({
      address: "",
      city: "",
      country: "",
      first_name: "",
      house_name: "",
      max_price: 2700,
      min_price: 100,
      region: "",
      room: "",
      zip_code: "",
      sort: "",
    });
    getHouses.refresh();
  };

  return (
    <Wrap>
      <Filter>
        <Filter.Card>
          <Filter.Title>Find Your New Home</Filter.Title>
          <Wrap.Input
            onChange={handleStateChange}
            placeholder="Enter Address"
            name="address"
            value={localState?.address}
          />
          <Wrap.Input
            onChange={handleStateChange}
            placeholder="Enter City"
            value={localState?.city}
            name="city"
          />
          <Wrap.Input
            onChange={handleStateChange}
            placeholder="Enter Country"
            value={localState?.country}
            name="country"
          />
          <Wrap.Input
            onChange={handleStateChange}
            placeholder="Enter Realtor Name"
            value={localState?.first_name}
            name="first_name"
          />
          <Wrap.Input
            onChange={handleStateChange}
            placeholder="Enter Realtor Surname"
            value={localState?.last_name}
            name="last_name"
          />
          <Wrap.Input
            onChange={handleStateChange}
            placeholder="Enter Rooms"
            value={localState?.room}
            name="room"
          />
          <Wrap.Input
            onChange={handleStateChange}
            placeholder="Enter Zip Code"
            value={localState?.zip_code}
            name="zip_code"
          />
          {/* <Filter.Select
            showSearch
            style={{ width: "100%" }}
            placeholder="Status"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            <Filter.Option value="1">Not Identified</Filter.Option>
            <Filter.Option value="2">Closed</Filter.Option>
            <Filter.Option value="3">Communicated</Filter.Option>
            <Filter.Option value="4">Identified</Filter.Option>
            <Filter.Option value="5">Resolved</Filter.Option>
            <Filter.Option value="6">Cancelled</Filter.Option>
          </Filter.Select> */}

          <Filter.Slider
            onChange={handleSlider}
            range={{ draggableTrack: true }}
            defaultValue={[10, 80]}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Filter.Price>${filtededFields?.min_price},00</Filter.Price>
            <Filter.Price>${filtededFields?.max_price},00</Filter.Price>
          </div>

          <Filter.Button onClick={handleFind}>
            <Filter.Search /> Search
          </Filter.Button>
          <Filter.Refresh onClick={refresh}>
            <Filter.Return /> Reset Search
          </Filter.Refresh>
        </Filter.Card>
      </Filter>
      <Houses>
        <Houses.Sort>
          {housesList.length > 0 ? (
            housesList?.map((item, index) => {
              return (
                <NavLink key={index} to={`/buy/${item?.id}`}>
                  <Card item={item} margin="15px 0" />
                </NavLink>
              );
            })
          ) : (
            <NoData />
          )}
        </Houses.Sort>

        {getHouses.isLoading ? (
          <div>Loading</div>
        ) : (
          <Wrap>
            <Pagination
              defaultCurrent={page}
              current={page}
              total={total && total}
              defaultPageSize={size}
              pageSize={size}
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              pageSizeOptions={["5", "10", "20", "50", "100"]}
              onChange={handlePaginationChange}
            />
          </Wrap>
        )}
      </Houses>
    </Wrap>
  );
}
